function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import get from 'lodash/get';
import cn from 'classnames';
import MeasurementsResult from 'svg/measurement-result.svg';
import ReadingFlagIcon from 'components/ReadingFlagIcon';
import * as shapes from '../../shapes';
import styles from './Reading.pcss';
var _React_PureComponent;
class Reading extends (_React_PureComponent = React.PureComponent) {
    renderIcon() {
        const { reading } = this.props;
        const { flag, type, isActive } = reading;
        const measurementTypeClass = styles[`reading__icon--${type}`];
        return /*#__PURE__*/ _jsx("div", {
            className: cn(styles.reading__icon, measurementTypeClass, 'ReadingIcon', {
                [styles['reading__icon--active']]: isActive
            }),
            children: /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                width: "13",
                height: "13",
                flag: flag
            })
        });
    }
    renderValue() {
        const displayValue = get(this.props, 'reading.displayValue', 0);
        return /*#__PURE__*/ _jsx("div", {
            className: styles.reading__text,
            children: displayValue
        });
    }
    render() {
        const { reading } = this.props;
        const { type, isActive } = reading;
        const measurementTypeClass = styles[`reading__badge--${type}`];
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.reading,
            children: [
                /*#__PURE__*/ _jsx(MeasurementsResult, {
                    width: "29",
                    height: "33",
                    className: `${measurementTypeClass} ${isActive ? styles['reading__badge--active'] : ''}`
                }),
                this.renderIcon(),
                this.renderValue()
            ]
        });
    }
}
_define_property(Reading, "propTypes", {
    // Explicit props
    reading: shapes.reading.isRequired
});
export default withStyles(styles)(Reading);
